module.exports = __webpack_public_path__ + "img/kkb_ledbar50.09ee2bdd.jpg";